import React from 'react';
import Helmet from 'react-helmet';
import View from '../components/View';
import ServiceView from '../components/ServiceView';
import IndexSecondView from '../components/IndexSecondView';
import ContactView from '../components/ContactView';
import FooterView from '../components/FooterView';
import pictureShowcase from './assets/img/picture_onmeasureapp.png';

const title = 'Applications sur mesure';
const description = `

Nous développons depuis 2001 des **logiciels**, des **applications mobiles** et tout autre projet que vous pourriez avoir. Notre équipe a su répondre au fil du temps aux différents besoins de nos clients tout en restant à la **pointe de la technologie**. Que votre projet soit un outil de gestion, une application mobile ou encore un site web complexe, [contactez-nous](#contact).

## Logiciels, progiciels, CRM ou ERP sur-mesures 
Le quotidien de votre entreprise est fait de **nombreuses tâches** qui peuvent être informatisées. Vous avez peut-être cherché des logiciels qui pourraient vous aider à **accomplir ces tâches** de manière plus efficace mais les outils que vous avez trouvés ne correspondent pas à ce que vous cherchez ou sont trop complexes.
Chez Com des Lézards, nous développons l'outil qui correspondra parfaitement à vos critères quel que soit votre métier. Nous avons déjà réalisé des outils sur mesures pour des besoins aussi variés que la **gestion/facturation** de centres de location de box de stockage ou un **planning complexe** avec **gestion client** pour une entreprise fabricant du matériel orthopédique.
Nous travaillons pour répondre à ces besoins avec les technologies récentes que sont **GraphQL**, **Node.js** et **React** mais nous avons parfaitement la capacité de nous adapter à vos besoins.

## Applications mobiles pour iOS et Android

Vous souhaitez vous lancer dans l'aventure mobile ou refondre votre application vieillissante, nous créerons pour vous celle-ci. Nous nous occupons de l'application mais aussi du serveur qui lui fournira toute sa logique. Pour faire ça nous travaillons avec les technologies **React Native** pour le développement de l'application en elle même et de **GraphQL** et **Node.js** pour ce qui est du serveur.

## Site web complexe

Vous avez un **projet web** qui n'est pas qu'un simple site vitrine et vous cherchez l'équipe qui pourra mener ce projet de bout en bout. De la création de la **maquette graphique** à la mise en ligne de votre site web en passant par le développement du **serveur** et du site web en lui même, nous pouvons mener à bien votre projet. Nous utilisons pour ça les technologies modernes que sont **GraphQL**, **Node.js** ou encore **React**. Ces technologies vont nous permettre de construire un site web fiable et évolutif autant côté client que côté serveur.

Maintenant parlons de votre projet et préparons ensemble les bases de la réalisation de celui-ci.
`;
const technos = ['GraphQL', 'React', 'Javascript', 'Node.js', 'AWS'];

const IndexPage = (props) => {
  const {
    data: {
      previewProjects,
    },
  } = props;
  return (
    <div>
      <Helmet
        meta={[
          {
            name: 'description',
            content: 'Création sur mesure de logiciels et applications mobiles.',
          },
        ]}
      />
      <View colorMode="2">
        <ServiceView
          picture={pictureShowcase}
          title={title}
          description={description}
          technologies={technos}
        />
        <IndexSecondView data={previewProjects} />
        <ContactView />
        <FooterView />
      </View>
    </div>

  );
};

export default IndexPage;

export const query = graphql`
  query  applicationsurmesure {
    previewProjects: allDatoCmsArticle(limit: 3, sort: {fields:[publicationDate], order:DESC}, filter: {
      articleType: {eq: "project"},
      tag: {eq: "application sur mesure"}
    }) {
      ...previewArticle
    }
  }
  `;



// WEBPACK FOOTER //
// ./src/pages/applications-sur-mesure.jsx